import React, { useEffect } from 'react';
import FileList from '../components/FileList';
import FolderTree from '../components/FolderTree';
import api from '../api';

const FileManager: React.FC = () => {
    // Removed unused setSelectedFile

    useEffect(() => {
        const loadFilesAndFolders = async () => {
            await api.fetchFiles('./fm.glow-in-the-dark.eu');
            await api.listFiles('./fm.glow-in-the-dark.eu', '', 1, 50, false);
        };

        loadFilesAndFolders();
    }, []);

    // Removed unused handleFileSelect and files/folders state

    return (
        <div className="file-manager">
            <FolderTree />
            <FileList />
            {/* MetadataPanel removed: selectedFile no longer exists */}
        </div>
    );
};

export default FileManager;